import Rete from 'rete'

import { nanoid } from 'nanoid/async'
import { App } from '../../App'
import CONST_SOCKET from '../../const/socket'
import { buttonModal } from './buttonModal'
import {
  createNewPostbackNode,
  updateNodeConnections, 
  removeConnectionsHavingUnmatch,
} from '../../utils/functions'

// eslint-disable-next-line
export default async (node, editor) => {
  const oldData = node.data
  const { value: buttonData } = await buttonModal(oldData, node)

  if (buttonData && Object.values(buttonData).length > 0) {
    // Create text unique ID if there is not any
    if (! ('postbackId' in node.data)) {
      node.data.postbackId = await nanoid(15)
    }

    Object.assign(node.data, buttonData)
    
    if ('new_post_back' === buttonData.buttonType) {
      if (node.outputs instanceof Map) {
        const buttonOutput = node.outputs.get(CONST_SOCKET.BUTTON_OUTPUT)
        if (buttonOutput instanceof Rete.Output) {
          if (0 === buttonOutput.connections.length) {
            attachNewPostbackToButtonNode(node)
          }
        }
      }
    }

    node.update()
    updateNodeConnections(node)

    const match = ['new_post_back']
    removeConnectionsHavingUnmatch(node, match, 'buttonOutput')
  }

  return false
}

const attachNewPostbackToButtonNode = async (node) => {
  const newPostbackNode = await createNewPostbackNode()
  newPostbackNode.position = [node.position[0] + 250, node.position[1]]

  App.editor.addNode(newPostbackNode)

  App.editor.connect(
    node.outputs.get('buttonOutput'),
    newPostbackNode.inputs.get('newPostbackInput')
  )
}